import React from "react";
import { Box, Typography, Avatar, alpha } from "@mui/material";
import { COLORS } from "../../styles/uiConstants";
import { useClinicTheme } from "../../theme";

/**
 * Sayfa üst başlık şeridi: ikon avatarı + başlık + açıklama + sağda aksiyonlar.
 * TabbedPageShell'in şeridiyle aynıdır (o da bunu kullanır); sekmesiz sayfalar
 * (Muayene, Finansal, Randevular …) doğrudan bunu kullanır.
 *
 * @param {React.ReactNode} icon
 * @param {React.ReactNode} title
 * @param {React.ReactNode} [subtitle]
 * @param {React.ReactNode} [action] - sağ taraftaki kontroller
 * @param {boolean} [divider=true] - beyaz zemin + alt çizgi; TabbedPageShell
 *   kendi sarmalayıcısını çizdiği için false geçer
 */
export default function PageHeaderBar({ icon, title, subtitle, action, divider = true }) {
  const { palette } = useClinicTheme();
  return (
    <Box
      component="header"
      sx={{
        px: { xs: 2, md: 4 },
        py: 2.5,
        display: "flex",
        alignItems: "center",
        gap: 2,
        flexWrap: "wrap",
        ...(divider
          ? { flexShrink: 0, bgcolor: COLORS.white, borderBottom: `1px solid ${COLORS.slate200}` }
          : {}),
      }}
    >
      <Avatar
        sx={{
          width: 44,
          height: 44,
          bgcolor: alpha(palette.primary, 0.08),
          color: palette.primary,
        }}
      >
        {icon}
      </Avatar>

      <Box sx={{ flex: 1, minWidth: 0 }}>
        <Typography
          variant="h6"
          component="h1"
          sx={{ fontWeight: 700, fontSize: "1.125rem", color: COLORS.slate800, lineHeight: 1.3 }}
        >
          {title}
        </Typography>
        {subtitle ? (
          <Typography variant="caption" component="p" sx={{ color: COLORS.slate400, fontSize: "0.75rem" }}>
            {subtitle}
          </Typography>
        ) : null}
      </Box>

      {action ? (
        <Box sx={{ flexShrink: 0, display: "flex", alignItems: "center", gap: 1.25, flexWrap: "wrap" }}>
          {action}
        </Box>
      ) : null}
    </Box>
  );
}
